import { useState, useCallback, useEffect } from "react";
import { WealthReaderWidget } from "../WealthReaderWidget/WealthReaderWidget";
import wealthReaderService, {
  TWealthReaderItem,
  TWRPortfolio,
} from "@/services/WealthReaderService";
import { useWealthReaderListener } from "@/components/Hooks/UseWealthReaderListener";

type TWealthReaderFlowProps = {
  wrItem: (data: TWRPortfolio[]) => void;
};

export const WealthReaderFlow: React.FC<TWealthReaderFlowProps> = ({
  wrItem,
}) => {
  const [operationId, setOperationId] = useState<string | null>(null);

  useEffect(() => {
    const createSession = async () => {
      try {
        const { operationId } =
          await wealthReaderService.createWealthReaderSession();

        setOperationId(operationId);
      } catch (error) {
        console.error("Error creando sesión Wealth Reader", error);
      }
    };

    createSession();
  }, []);

  const handleCompleted = useCallback(async () => {
    if (!operationId) return;

    try {
      const result = await wealthReaderService.wealthreaderItem(operationId);
      console.log("Datos obtenidos del backend:", result); // TODO - REMOVE
      wrItem(result);
    } catch (err) {
      console.error("Error al obtener datos:", err);
    }
  }, [operationId, wrItem]);

  useWealthReaderListener(handleCompleted);

  if (!operationId) return null;

  return <WealthReaderWidget operationId={operationId} />;
};
